import { envVariables } from "../env";
import { RoutePaths } from "../routes/RoutePaths";
import Analytics from "./analytics";

import Session from "./session";

const Authentication = {
  authenticate: ({ accessToken = "", userId = "", email = "" }) => {
    Session.accessToken = accessToken;
    Session.userId = userId;
    Session.loggedIn = true;
    window.heap.identify(email);
    Analytics.identify(email.toLowerCase());
  },

  updateBeacon: ({ email, name, phone }) => {
    if (envVariables.REACT_APP_BEACON_ID) {
      window.Beacon("identify", {
        name,
        email,
        phone,
      });
    }
  },

  updateHeap: ({ email }) => {
    if (envVariables.REACT_APP_HEAP_ID) {
      window.heap.clearEventProperties();
      window.heap.addUserProperties({
        email,
      });
      window.heap.addEventProperties({
        "Logged In": "true",
        "User Email": email,
      });
    }
  },

  clear() {
    // Store session data we don't want to clear to variables
    const { vendorName } = Session;

    // Clear all session data
    Session.clearSession();

    // Store variables back to session storage
    Session.vendorName = vendorName;

    if (envVariables.REACT_APP_BEACON_ID) {
      window.Beacon("logout");
    }
    if (envVariables.REACT_APP_HEAP_ID) {
      window.heap.removeEventProperty("Logged In");
      window.heap.resetIdentity();
    }
  },
  clearAndRedirect(path: RoutePaths) {
    this.clear();
    window.location.replace(`${window.location.origin}${path}`);
  },
  verify() {
    return !!(Session.accessToken && Session.userId);
  },
};

export default Authentication;
